import {HttpClient} from "../../service/httpClient/HttpClient";
import {setLoadingStateDispatch} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes} from "../../context/SnackBarContext";

export class TagService {

    constructor(fundID, token, snackbar, loading) {
        this.fundID = fundID;
        this.token = token;
        this.snackbar = snackbar;
        this.loading = loading;

        this.httpClient = new HttpClient()
    }


    getTags(page, size = 10) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${this.fundID}/tags`,
                this.httpClient.prepareUserAccessHeader(this.token),
                {
                    page, size
                }
            ).then(resolve).catch(reject)
        })
    }

    addNewTag(name, clearFields) {
        this.loading(setLoadingStateDispatch(true))

        this.httpClient.post(
            `fund-presentation/funds/${this.fundID}/tags`,
            {name},
            this.httpClient.prepareUserAccessHeader(this.token)
        ).then(response => {
            clearFields()
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "تگ جدید با موفقیت افزوده شد."))
            this.loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در افزودن تگ جدید!"))
            this.loading(setLoadingStateDispatch(false))

        })
    }

    getTAgInfo(tagId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${this.fundID}/tags/${tagId}`,
                this.httpClient.prepareUserAccessHeader(this.token)
            ).then(resolve).catch(reject)
        })
    }

    updateTag(tagId, name) {
        this.loading(setLoadingStateDispatch(true))

        this.httpClient.put(
            `fund-presentation/funds/${this.fundID}/tags/${tagId}`,
            this.httpClient.prepareUserAccessHeader(this.token),
            {name}
        ).then(response => {
            this.loading(setLoadingStateDispatch(false))
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "بروزرسانی با موفقیت انجام شد."))
        }).catch(reason => {
            this.loading(setLoadingStateDispatch(false))
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در بروزرسانی تگ!"))
        })
    }

    deleteTag(tagId) {
        return new Promise((resolve, reject) => {
            this.httpClient.delete(
                `fund-presentation/funds/${this.fundID}/tags/${tagId}`,
                this.httpClient.prepareUserAccessHeader(this.token)
            ).then(resolve).catch(reject)
        })
    }

    getAllTags() {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${this.fundID}/tags/offers`,
                this.httpClient.prepareUserAccessHeader(this.token)
            ).then(resolve).catch(reject)
        })
    }
}